module.exports = __webpack_public_path__ + "img/wav.cb338954.svg";